import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const v1BindingList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/order_shop_agent/list?` + params,
    method: "GET",
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
export const v1BindingBindingShop = (data) => {
  //绑定商户
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/order_shop_agent`,
    method: "POST",
    data: data,
  });
};
export const v1BindingDetermine = (params) => {
  //检查商户是否注册
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/determine?` + params,
    method: "GET",
  });
};
export const delShop = (deleteOption, ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/order_shop_agent/${temp}?option=${deleteOption}`,
    method: "DELETE",
  });
};
// 注册商户
export const v1BindingRegistryShop = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/order_shop_agent/registry`,
    method: "POST",
    data: data,
  });
};
